import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getStatistic, userSelector } from '../../services/reduxSlices/UserSlice';
import Pagination from '../Pagination/Pagination'

/**
 * Ce Composant envellope les lignes d'un tableau 
 * 
 * @param {children} param0 
 * @returns TableWrapper
 * 
 */
export default function TableWrapper({ children, setPage, currentPage, maxPage, onApplySearch, onApplyFilter, status }) {
    const { stats } = useSelector(userSelector)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getStatistic())
    }, [])

    const getTotalNb = (data) => {
        if(data){
            const result = data.en_attente + data.en_cours + data.refuse + data.signe
            return result
        }
     
        return 0
    }

    return (
        <div id="kt_content_container" className="d-flex flex-column-fluid align-items-start container-xxl">
            <div className="content flex-row-fluid" id="kt_content">
                <div className="card card-flush pb-8">
                    <div className="card-header align-items-center py-5 gap-2 gap-md-5">
                        <div className="card-title">
                            <div className="d-flex align-items-center position-relative my-1">
                                <span className="svg-icon svg-icon-1 position-absolute ms-4">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="currentColor" />
                                        <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="currentColor" />
                                    </svg>
                                </span>
                                <input type="text" onClick={(e) => onApplySearch(e)} data-kt-ecommerce-product-filter="search" className="form-control form-control-solid w-250px ps-14" placeholder="Rechercher un document" />
                                <input type="button" onClick={(e) => onApplyFilter("0")} className="form-control form-control-solid w-150px ps-5 filter-status" value={`Tous (${getTotalNb(stats)})`} />
                                <input type="button" onClick={(e) => onApplyFilter("signe")} className={`form-control form-control-solid w-150px ps-5 filter-status ${status === 'signe' && 'signer-btn'}`} value={`Signés (${stats ? stats.signe : 0})`} />
                                <input type="button" onClick={(e) => onApplyFilter("en_attente")} className={`form-control form-control-solid w-150px ps-5 filter-status ${status === 'en_attente' && 'en_attente-btn'}`} value={`En attente (${stats ? stats.en_attente : 0})`} />
                                <input type="button" onClick={(e) => onApplyFilter("en_cours")} className={`form-control form-control-solid w-150px ps-5 filter-status ${status === 'en_cours' && 'en_cour-btn'}`} value={`En cours (${stats ? stats.en_cours : 0})`} />
                                <input type="button" onClick={(e) => onApplyFilter("refuse")} className={`form-control form-control-solid w-150px ps-5 filter-status ${status === 'refuse' && 'refuse-btn'}`} value={`Refusés (${stats ? stats.refuse : 0})`} />
                            </div>
                        </div>
                    </div>

                    <div className="card-body table-responsive">
                        <table className="table align-middle table-row-dashed fs-6 gy-5" id="kt_ecommerce_products_table">
                            <thead>
                                <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                                    <th className="w-10px pe-2">
                                        <div className="form-check form-check-sm form-check-custom form-check-solid me-3">
                                            <input className="form-check-input" type="checkbox" data-kt-check="true" data-kt-check-target="#kt_ecommerce_products_table .form-check-input" value="1" />
                                        </div>
                                    </th>
                                    <th className="min-w-200px">Documents</th>
                                    <th className="text-end min-w-100px">Recu le</th>
                                    <th className="text-end min-w-100px">Status</th>
                                    <th className="text-end min-w-70px">Actions</th>
                                </tr>
                            </thead>

                            <tbody className="fw-bold text-gray-600">
                                {children}
                            </tbody>
                        </table>
                    </div>
                    <Pagination setPage={setPage} currentPage={currentPage} maxPage={maxPage <= 3 ? 3 : maxPage} />
                </div>
            </div>
        </div>
    )
}
